import React from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';

import { PinVerification } from './components';

import style from './PinVerificationPopup.scss';

const popupClassNames = {
    inner: style.popupInner
};

const layerClassNames = {
    layout: style.layout
};

export const PinVerificationPopup = ({ id, controls, isSSO, onSuccess, onClose }) => {
    const closePopup = useCombinedOnClose(onClose, id);

    return (
        <ManagedPopup
            id={id}
            controls={controls}
            onClose={closePopup}
            className={style.container}
            classNames={popupClassNames}
            layerClassNames={layerClassNames}
        >
            <PinVerification
                isSSO={isSSO}
                onClose={closePopup}
                onSuccess={onSuccess}
            />
        </ManagedPopup>
    );
};
